/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Delete_Draft_ConfirmInputs */

const cs_property_ai_delete_draft_confirm = /** @type {(inputs: Property_Ai_Delete_Draft_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tento AI návrh fotky?`)
};

const en_property_ai_delete_draft_confirm = /** @type {(inputs: Property_Ai_Delete_Draft_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this AI draft photo?`)
};

/**
* | output |
* | --- |
* | "Delete this AI draft photo?" |
*
* @param {Property_Ai_Delete_Draft_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_delete_draft_confirm = /** @type {((inputs?: Property_Ai_Delete_Draft_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Delete_Draft_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_delete_draft_confirm(inputs)
	return cs_property_ai_delete_draft_confirm(inputs)
});